import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import DashboardContainer from '@/containers/Dashboard';
import { GlobalContext } from '@/contexts/GlobalContext';

function Dashboard() {
  const { t } = useTranslation();
  const { setPageTitle, setTriggerFetchProfile } = useContext(GlobalContext);

  useEffect(() => {
    setPageTitle({
      title: t('dashboard.page_title'),
    });
    setTriggerFetchProfile(true);
  }, [setPageTitle, t, setTriggerFetchProfile]);

  return (
    <div className="dashboard-page">
      <DashboardContainer />
    </div>
  );
}

export default Dashboard;
